import { Star } from "lucide-react";
import { REVIEWS } from "../data/reviews";
import { Reveal } from "./Reveal";

const Stars = () => (
  <div className="flex gap-1 text-neutral-950" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} strokeWidth={1} fill="currentColor" />)}
  </div>
);

export const Reviews = () => (
  <section className="bg-white py-24 md:py-32" data-testid="reviews-section">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8">
      <Reveal className="mb-16 text-center">
        <p className="kicker">5.0 · 5-Star Ratings From Our Clients</p>
        <h2 className="font-display mt-3 text-4xl font-light text-neutral-950 md:text-5xl">In their words</h2>
      </Reveal>
      <div className="grid gap-px bg-neutral-200 md:grid-cols-2 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <figure key={r.name} className="flex flex-col bg-white p-8 md:p-10" data-testid={`review-card-${i}`}>
            <Stars />
            <blockquote className="font-display mt-6 flex-1 text-xl font-light italic leading-snug text-neutral-900 md:text-2xl">“{r.text}”</blockquote>
            <figcaption className="kicker mt-8">{r.name} · {r.treatment}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
